// extracted by mini-css-extract-plugin
export default {"container":"iZ8LUeQ8","left":"o2tZs478","right":"BiSWvaoC","brand":"hdV9oksl","avatar":"w4PBzETc","profile":"z2K5pmBp","breadcrumbsContainer":"IcN8pNSx"};